<tlk-modal-header [id]="'save-and-continue-later-header'" header>
	<span class="save-and-continue-later__title">{{ 'SaveAndContinueLater.Title' | translate }}</span>
</tlk-modal-header>

<tlk-modal-content content>
	<p class="save-and-continue-later__subtitle">{{ 'SaveAndContinueLater.Subtitle' | translate }}</p>
	<p class="save-and-continue-later__helper">{{ 'SaveAndContinueLater.HelperText' | translate }}</p>

	<tlk-radio-group
		name="saveAndContinueLaterOption"
		class="save-and-continue-later__options"
		[(ngModel)]="selectedOption"
	>
		<div
			class="save-and-continue-later__option"
			[class.save-and-continue-later__option_selected]="selectedOption === 'continueOnScanner'"
			data-testid="save-and-continue-later-option-continue-on-scanner"
			(click)="selectContinueOnScanner()"
		>
			<tlk-radio-button
				class="save-and-continue-later__radio"
				value="continueOnScanner"
				[checked]="selectedOption === 'continueOnScanner'"
			></tlk-radio-button>
			<span class="save-and-continue-later__option-icon save-and-continue-later__option-icon_scanner">
				<rx-save-continue-scanner-icon />
			</span>
			<div class="save-and-continue-later__option-text">
				<span class="save-and-continue-later__option-title">
					{{ 'SaveAndContinueLater.ContinueOnScannerTitle' | translate }}
				</span>
				<span class="save-and-continue-later__option-subtext">
					{{ 'SaveAndContinueLater.ContinueOnScannerSubtext' | translate }}
				</span>
			</div>
		</div>

		<div
			class="save-and-continue-later__option"
			[class.save-and-continue-later__option_selected]="selectedOption === 'completeOnDentira'"
			data-testid="save-and-continue-later-option-complete-on-dentira"
			(click)="selectCompleteOnDentira()"
		>
			<tlk-radio-button
				class="save-and-continue-later__radio"
				value="completeOnDentira"
				[checked]="selectedOption === 'completeOnDentira'"
			></tlk-radio-button>
			<span class="save-and-continue-later__option-icon save-and-continue-later__option-icon_dentira">
				<rx-save-continue-lab-broker-icon />
			</span>
			<div class="save-and-continue-later__option-text">
				<span class="save-and-continue-later__option-title">
					{{ 'SaveAndContinueLater.CompleteOnDentiraTitle' | translate: { name: data.name } }}
				</span>
				<span class="save-and-continue-later__option-subtext">
					{{ 'SaveAndContinueLater.CompleteOnDentiraSubtext' | translate: { name: data.name } }}
				</span>
			</div>
		</div>
	</tlk-radio-group>
</tlk-modal-content>

<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button
			tlkButton
			variant="secondary"
			size="m"
			data-testid="save-and-continue-later-cancel"
			(click)="cancel()"
		>
			{{ 'SaveAndContinueLater.Cancel' | translate }}
		</button>
		<button
			tlkButton
			variant="primary"
			size="m"
			data-testid="save-and-continue-later-confirm"
			[disabled]="isConfirmDisabled"
			(click)="confirm()"
		>
			{{ 'SaveAndContinueLater.Confirm' | translate }}
		</button>
	</ng-container>
</tlk-modal-footer>
